import { store } from '@/store';
const axios = require('axios');

// Make Axios play nice with Django CSRF
axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFToken';

/// ////////////////////////////////////////////////////////////////////

let api = {
    apiClient() {
        const base = {
            baseURL: '/api/v1/',
            headers: {
                'Content-Type': 'application/json',
            },
            xhrFields: {
                withCredentials: true,
            },
        };

        let jwt = store.getters.getField('jwt');

        if (jwt !== undefined) {
            base.headers = {
                'Content-Type': 'application/json',
                Authorization: `JWT ${jwt}`,
            };
        }
        return axios.create(base);
    },
    getMarkers() {
        return new Promise((resolve, reject) => {
            this.apiClient()
                .get('carto/markers/')
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    console.debug(error);
                    reject(error);
                });
        });
    },
    getPolylines() {
        return new Promise((resolve, reject) => {
            this.apiClient()
                .get('carto/polylines/')
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    console.debug(error);
                    reject(error);
                });
        });
    },
    getPolygons() {
        return new Promise((resolve, reject) => {
            this.apiClient()
                .get('carto/polygons/')
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    console.debug(error);
                    reject(error);
                });
        });
    },
    saveService(data) {
        return new Promise((resolve, reject) => {
            this.apiClient()
                .post('carto/markers/', data)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    console.debug(error);
                    reject(error);
                });
        });
    },
    saveRoad(data) {
        return new Promise((resolve, reject) => {
            this.apiClient()
                .post('carto/polylines/', data)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    console.debug(error);
                    reject(error);
                });
        });
    },
    // template(user_id) {
    //     return new Promise((resolve, reject) => {
    //         this.apiClient()(
    //             {
    //                 url: '',
    //                 method: "get",
    //                 params: {},
    //             }
    //         )
    //             .then((response) => {
    //                 resolve(response.data);
    //             })
    //             .catch((error) => {
    //                 console.debug(error);
    //                 reject(error);
    //             })
    //     })
    // },

};

export default api;
